export enum DocumentTypeEnum {
  // SDS_日本語
  SDS_JP = '01',
  // SDS_中国語
  SDS_CN = '02',
  // SDS_英語
  SDS_EN = '03',
  // SDS_その他言語
  SDS_OTHER = '04',
  // イエローカード
  YELLOW_CARD = '05',
  // REACH
  REACH = '06',
  // ケムシェルパ
  CHEM_SHERPA = '07',
  // SVHC
  SVHC = '08',
  // RoHS
  ROHS = '09',
  // 化学品その他
  OTHER_CHEMICALS = '10',
  // LCA
  LCA = '11',
}
